import _regeneratorRuntime from 'babel-runtime/regenerator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ResultInt from '../_interface/result-int';
import resultAdapter from '../_util/result-adapter';
import { Container } from '../uplus-api/container/container';
import upTraceModule from '../h5_exports/upTraceModule';
import upAppinfoModule from '../h5_exports/upAppinfoModule';
import upStorageModule from '../h5_exports/upStorageModule';
import upLogModule from '../h5_exports/upLogModule';
import upNativeContainerModule from '../h5_exports/upNativeContainerModule';
import loadArmsAsync from './loadArmsAsync';
export var Neubla = function (_Container) {
    _inherits(Neubla, _Container);

    function Neubla() {
        _classCallCheck(this, Neubla);

        var _this = _possibleConstructorReturn(this, (Neubla.__proto__ || Object.getPrototypeOf(Neubla)).apply(this, arguments));

        _this.deviceReady = false;
        _this.androidKeyBackChangeListener = null;
        _this.upAlbumModule = null;
        _this.upAlipayModule = null;
        _this.upAppinfoModule = null;
        _this.upAudioRecorderModule = null;
        _this.bindModule = null;
        _this.upBleModule = null;
        _this.upDeviceModule = null;
        _this.upFamilyModule = null;
        _this.upHttpModule = null;
        _this.upImageModule = null;
        _this.upInfraredModule = null;
        _this.upLiveModule = null;
        _this.upLocationModule = null;
        _this.upLogModule = null;
        _this.upLogicEngineModule = null;
        _this.upMakeSignModule = null;
        _this.upNativeContainerModule = null;
        _this.upNetworkModule = null;
        _this.upOSSModule = null;
        _this.upPedometerModule = null;
        _this.upPermissionModule = null;
        _this.upRequestModule = null;
        _this.upResourceModule = null;
        _this.upShareModule = null;
        _this.upSpeechRecognitionModule = null;
        _this.upStorageModule = null;
        _this.upSystemModule = null;
        _this.upTraceModule = null;
        _this.upUserModule = null;
        _this.upVdnModule = null;
        _this.upWeiXinModule = null;
        _this.upWifiModule = null;
        _this.upBindConfigModule = null;
        _this.upDiscoverDeviceModule = null;
        _this.upNetworkConfigModule = null;
        _this.upUSDKFOTAModule = null;
        _this.upAlexaAuthModule = null;
        _this.upUnionPayModule = null;
        /* 版本对比, 针对a.b.c, abc的位数不限制 */
        _this.versionIsLessThan = function (v1, v2) {
            var result = [0, 0, 0];
            if (v1 && v2 && /(\d+\.){2}\d+/.test(v1) && /(\d+\.){2}\d+/.test(v2)) {
                var v1Arr = v1.split('.');
                var v2Arr = v2.split('.');
                if (v1Arr.length === v2Arr.length) {
                    for (var i = 0; i < v1Arr.length; i++) {
                        if (parseInt(v1Arr[i], 10) < parseInt(v2Arr[i], 10)) {
                            result[i] = -1;
                            if (i === 0 || i === 1 && result[0] === 0) {
                                break;
                            }
                        } else if (parseInt(v1Arr[i], 10) === parseInt(v2Arr[i], 10)) {
                            result[i] = 0;
                        } else {
                            result[i] = 1;
                        }
                    }
                }
            }
            return result[0] === -1 || result[0] === 0 && result[1] === -1 || result[0] === 0 && result[1] === 0 && result[2] === -1;
        };
        return _this;
    }

    _createClass(Neubla, [{
        key: 'initDeviceReady',
        value: function initDeviceReady() {
            var _this2 = this;

            var self = this;
            document.container = self;
            return new Promise(function (resolve) {
                if (self.deviceReady) {
                    resolve(new ResultInt('000000', ''));
                } else {
                    document.addEventListener('AlipayJSBridgeReady', function () {
                        // 初始化页面点击事件监听
                        /**
                        @brief 优先加载upNativeContainerModule 保证蓝牙状态监听和网络状态监听成功
                        @discussion 蓝牙状态监听和网络状态监听是在其模块初始化的时候挂载的，
                        此时upNativeContainerModule若未实例化，会导致原生层对此监听名称的计数为0，
                        iOS中callHandler的逻辑中会阻断监听信息上报
                        */
                        if (!self.deviceReady) {
                            self.initUplusTrace();
                            if (self.extras) {
                                Object.entries(self.extras).forEach(function (_ref) {
                                    var _ref2 = _slicedToArray(_ref, 2),
                                        key = _ref2[0],
                                        value = _ref2[1];

                                    self[key] = value;
                                });
                            }
                            _this2.upTraceModule = upTraceModule;
                            _this2.upAppinfoModule = upAppinfoModule;
                            loadArmsAsync(upAppinfoModule);
                            _this2.upLogModule = upLogModule;
                            _this2.upStorageModule = upStorageModule;
                            _this2.upNativeContainerModule = upNativeContainerModule;
                            window.console.info('Neubla addEventListener resume');
                            self.addEventListener('resume', null, function (data) {
                                window.console.log('Neubla resume EventListener callBack', data);
                                self.onContainerResumeEventWithParam(data);
                            }).then(function (result) {
                                window.console.log('Neubla addEventListener result', result);
                            })['catch'](function (err) {
                                window.console.log('Neubla addEventListener err', err);
                            });
                            self.addEventListener('pause', null, function () {
                                self.onContainerPauseEvent();
                            });
                            self.addEventListener('back', null, function () {
                                self.onContainerBackEvent();
                            });
                        }
                        self.deviceReady = true;
                        resolve(new ResultInt('000000', ''));
                    }, false);
                }
            });
        }
    }, {
        key: 'closeH5ContainerView',
        value: function closeH5ContainerView() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                if (window.AlipayJSBridge) {
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                        _this3.upAppinfoModule.getAppInfo().then(function (result) {
                            var _a;
                            // console.log('result', result);
                            var lessVersion = _this3.versionIsLessThan((_a = result.retData) === null || _a === void 0 ? void 0 : _a.appVersion, '6.17.0');
                            if (!lessVersion) {
                                window.AlipayJSBridge.call('closeView');
                            } else {
                                window.AlipayJSBridge.call('popWindow');
                            }
                        }, function () {
                            // console.log('err', err);
                        });
                    } else {
                        window.AlipayJSBridge.call('manualCloseH5page');
                    }
                    resolve(resultAdapter({
                        retCode: '000000',
                        retInfo: '操作成功',
                        retData: ''
                    }));
                } else {
                    reject(resultAdapter({
                        retCode: '100001',
                        retInfo: '基础模块未定义!!!',
                        retData: ''
                    }));
                }
            });
        }
    }, {
        key: 'manualCloseH5page',
        value: function manualCloseH5page() {
            return new Promise(function (resolve, reject) {
                if (window.AlipayJSBridge) {
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                        window.AlipayJSBridge.call('closeView');
                    } else {
                        window.AlipayJSBridge.call('manualCloseH5page');
                    }
                    resolve(resultAdapter({
                        retCode: '000000',
                        retInfo: '操作成功',
                        retData: ''
                    }));
                } else {
                    reject(resultAdapter({
                        retCode: '100001',
                        retInfo: '基础模块未定义!!!',
                        retData: ''
                    }));
                }
            });
        }
    }, {
        key: 'getUrlParams',
        value: function getUrlParams() {
            return new Promise(function (resolve) {
                resolve(resultAdapter({
                    retCode: '000000',
                    retInfo: '操作成功',
                    retData: {
                        hash: window.location.hash || '',
                        search: window.location.search || ''
                    }
                }));
            });
        }
    }, {
        key: 'getStatusBarHeight',
        value: function getStatusBarHeight() {
            return new Promise(function (resolve, reject) {
                if (window.AlipayJSBridge) {
                    window.AlipayJSBridge.call('getStatusBarHeightForAction', null, function (data) {
                        resolve(resultAdapter({
                            retCode: '000000',
                            retInfo: '\u8C03\u7528\u51FD\u6570getStatusBarHeightForAction\u6210\u529F',
                            retData: {
                                height: data.retData.height
                            }
                        }));
                    });
                } else {
                    reject(resultAdapter({
                        retCode: '100001',
                        retInfo: '基础模块未定义!!!',
                        retData: {
                            height: ''
                        }
                    }));
                }
            });
        }
    }, {
        key: 'androidPhysicalBtForBack',
        value: function androidPhysicalBtForBack(params) {
            var _this4 = this;

            // const self = this;
            return new Promise(function (resolve, reject) {
                return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _this5 = this;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;

                                    if (!(!params || typeof params.process !== 'boolean')) {
                                        _context.next = 3;
                                        break;
                                    }

                                    throw Error('process 入参不正确');

                                case 3:
                                    if (!(params && params.process === true && !params.deviceChangeListener)) {
                                        _context.next = 5;
                                        break;
                                    }

                                    throw Error('deviceChangeListener 不允许为空');

                                case 5:
                                    if (window.AlipayJSBridge) {
                                        window.AlipayJSBridge.call('processBack', params, function (ret) {
                                            if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' && resolve) {
                                                if (params.process) {
                                                    _this5.addPhysicalBackStack(params.deviceChangeListener, params.eventKey || 'backEvent');
                                                } else {
                                                    _this5.removePhysicalBackStack(params.eventKey);
                                                }
                                                resolve(resultAdapter({
                                                    retCode: '000000',
                                                    retInfo: '操作成功',
                                                    retData: ''
                                                }));
                                            } else if (reject) {
                                                reject(resultAdapter({
                                                    retCode: '100000',
                                                    retInfo: '操作失败',
                                                    retData: ''
                                                }));
                                            }
                                        });
                                    } else {
                                        reject(resultAdapter({ retCode: '100001', retInfo: '基础模块未定义!!!', retData: '' }));
                                    }
                                    _context.next = 11;
                                    break;

                                case 8:
                                    _context.prev = 8;
                                    _context.t0 = _context['catch'](0);
                                    throw Error(_context.t0);

                                case 11:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[0, 8]]);
                }));
            });
        }
    }]);

    return Neubla;
}(Container);